import instance from "../../utils/customizedAxiosConfig";
import fetchEnv from "../../utils/FetchEnv";

const caseUrl = fetchEnv()?.REACT_APP_APIURL_CASE;

export const getRolePermissionsList = (data) => {
  const subtenantId = JSON.parse(localStorage.getItem("tenantDetails"))?.subtenantId;
  return instance.get(`${caseUrl}/caseManagement/api/getPermissionsByRoles?roleNames=${data}`, {
    headers: {
      subtenantid: subtenantId,
      product: "msafety",
    },
  });
};
